import { useItemWorkflowTableStore } from '../business';
import { getItemAvailableQuantity } from './getItemAvailableQuantity';
import { scrollItemToIndex } from './scrollItemToIndex';
/** Works both for virtualized table and memoed table. */
export function setSelectionBySearchTerm({ items, fieldToSearchBy, searchTerm, tableVirtuosoRef, tableScrollingContainerRef, }) {
    if (!items || !fieldToSearchBy || !searchTerm)
        return;
    const { setCurrentItemIndex } = useItemWorkflowTableStore.getState();
    // 1. Item value should include `searchTerm`. Absolute equality is not necessary here.
    // 2. Should locate only not fully receipted items.
    // 3. Data should not be filtered by `availableQuantity` first since in this case the itemIndex will be 'broken' - it will be
    //    an index of **filtered** items, but we need an index of **all** items.
    // 4. Performance check found out that `indexOf()` should go first inside the condition,
    //    before the `getReceiptItemAvailableQuantity()` function call.
    const itemIndex = items.findIndex((item) => item[fieldToSearchBy].indexOf(searchTerm) !== -1 && getItemAvailableQuantity(item) > 0);
    if (tableScrollingContainerRef?.current) {
        scrollItemToIndex(tableScrollingContainerRef, itemIndex);
    }
    else if (tableVirtuosoRef?.current) {
        tableVirtuosoRef.current?.scrollToIndex({ index: itemIndex === -1 ? 0 : itemIndex, align: 'center', behavior: 'auto' });
    }
    setCurrentItemIndex(itemIndex);
}
